import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchTimeBasedRegistrationData = async (type: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      type,
    },
    query: graphql(`
      query TimeBasedRegistrationData($type: String!) {
        timeBasedRegistrationData(type: $type) {
          month
          category
          count
          activeCallersByMonth {
            month
            numberofActiveClients
          }
        }
      }
    `),
  });

  return response.data.timeBasedRegistrationData ?? [];
};
